import { useSelector } from 'react-redux';

const useActiveItem = () => {
  const activeItem = useSelector((state) => state.cards.activeItem);
  const isActiveItem = !!activeItem;

  return { activeItem, isActiveItem };
};

export default useActiveItem;
